import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { IAgentActivityReport } from '@obvious.tech/constellation'

export const AgentActivityReport = defineEntity('AgentActivityReport', {
  endpoint: 'units/api/AgentActivityReport',
  schema: SNoop<IAgentActivityReport>(),
})
